/* Redirect Logout Script redirect-logout.js */
  document.addEventListener('DOMContentLoaded', function () {
    // Find all anchor links pointing to /account/logout
    const links = document.querySelectorAll('a[href="/account/logout"]');

    // Loop through the links and add an onclick event
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault(); // Prevent default logout behavior
        console.log('Logout link clicked. Redirecting to /pages/login/');

        // Perform the logout and redirect
        fetch('/account/logout', { method: 'POST' }) // Sends the logout request
          .then(() => {
            window.location.href = '/pages/login/'; // Redirect to the login page
          })
          .catch((error) => console.error('Error during logout:', error));
      });
    });

    console.log(links.length > 0 
      ? `Found ${links.length} logout link(s). Onclick event added.` 
      : 'No logout links found.');
  });